window.dialogData = function (defaultFilters) {
    return {
        isDialogOpen: false,
        filters: {},
        lockBody(isDialogOpen) {
            if (isDialogOpen) {
                document.body.classList.add('overflow-y-hidden')
            } else {
                document.body.classList.remove('overflow-y-hidden')
            }
        },
        submitForm() {
            this.updateUrlParams()
            this.isDialogOpen = false
        },
        clearForm() {
            for (let [key, value] of Object.entries(this.filters)) {
                this.filters[key] = []
            }
        },
        removeFilter(slug, term) {
            const filters = JSON.parse(JSON.stringify(this.filters))

            this.filters[slug] = filters[slug].filter((item) => {
                if (item === term) {
                    return false
                }
                return true
            })

            this.updateUrlParams()
        },
        getSelectedFilters() {
            const filters = JSON.parse(JSON.stringify(this.filters))

            const selected = []

            Object.keys(filters).forEach((key) => {
                filters[key].forEach((term) => {
                    selected.push({
                        term: term,
                        slug: key,
                    })
                })
            })

            return selected
        },
        getInitialFiltersFromUrl() {
            const urlParams = new URLSearchParams(window.location.search)

            for (let [key, value] of Object.entries(this.filters)) {
                if (urlParams.has(key) && urlParams.get(key).length !== 0) {
                    this.filters[key] = urlParams.get(key).split(',')
                }
            }
        },
        updateUrlParams() {
            window.history.replaceState(null, null, window.location.pathname)

            const url = new URL(window.location)
            const formData = JSON.parse(JSON.stringify(this.filters))

            Object.keys(formData).forEach(function (key) {
                if (formData[key].length > 0) {
                    url.searchParams.set(key, formData[key])
                }
            })

            window.history.pushState({}, '', url)

            window.dispatchEvent(new Event('popstate'))
        },
        createFilters() {
            defaultFilters.forEach((filter) => {
                this.filters[filter] = []
            })
        },
    }
}
